/* eslint-disable react-hooks/exhaustive-deps */
import { Table, Tag, Button } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";

import UpdateAdminConfigModal from "./ModifyConfigModal";
import NewAdminFormModal from "./NewAdminFormModal";
import { showErrorNotification, showSuccessNotification } from "../../utils/notification";
import { clamp } from "../../utils/responsiveHelpers";

const AdminManagementDash = ({ userConfig, ROOT_URL }) => {
  const [createAdminModalOpen, setCreateAdminModalOpen] = useState(false);
  const [modifyConfigModalOpen, setModifyConfigModalOpen] = useState(false);
  const [currentAdminConfig, setCurrentAdminConfig] = useState({});
  const [currentAdminId, setCurrentAdminId] = useState({});
  const [adminList, setAdminsList] = useState([]);

  const fetchAdminsList = () => {
    axios
      .get(`${ROOT_URL}/admin/core/admin/list`, {})
      .then((res) => {
        const { admins } = res.data;
        setAdminsList(admins);
        showSuccessNotification("Admins fetched successfully!");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleCreateAdmin = (adminDetails) => {
    axios
      .post(`${ROOT_URL}/admin/core/admin/create`, {
        ...adminDetails
      })
      .then(() => {
        showSuccessNotification("Admin created Successfully");
        fetchAdminsList();
        setCreateAdminModalOpen(false);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleBlockAdmin = (adminId) => {
    axios
      .post(`${ROOT_URL}/admin/core/admin/block`, {
        adminId
      })
      .then(() => {
        showSuccessNotification("Admin Blocked Successfully");
        fetchAdminsList();
        setCreateAdminModalOpen(false);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const updateAdminConfig = () => {
    axios
      .post(`${ROOT_URL}/admin/core/admin/update-config`, {
        adminId: currentAdminId,
        updatedConfig: currentAdminConfig
      })
      .then(() => {
        showSuccessNotification("Admin Config Updated Successfully");
        fetchAdminsList();
        setModifyConfigModalOpen(false);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const updateAdminConfigState = (key, subKey, value) => {
    setCurrentAdminConfig({
      ...currentAdminConfig,
      [key]: {
        ...currentAdminConfig[key],
        [subKey]: value
      }
    });
  };

  const columns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name"
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email"
    },
    {
      title: "Contact Number",
      dataIndex: "contactNumber",
      key: "contactNumber"
    },
    {
      title: "Status",
      key: "blocked",
      dataIndex: "blocked",
      render: (blocked) => {
        const color = blocked ? "red" : "green";
        return (
          <Tag color={color} key={blocked ? "Blocked" : "Active"}>
            {blocked ? "Blocked" : "Active"}
          </Tag>
        );
      }
    },
    {
      title: "Actions",
      key: "action",
      render: (row) => (
        <div
          id="admin_row_actions"
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-around",
            gap: "8px"
          }}
        >
          <Button
            danger
            disabled={!userConfig?.admins?.hasManageAccess}
            type="primary"
            onClick={() => {
              handleBlockAdmin(row.key);
            }}
          >
            {row.blocked ? "Un Block" : "Block"}
          </Button>
          <Button
            type="primary"
            disabled={!userConfig.admins.hasManageAccess}
            onClick={() => {
              setCurrentAdminConfig(row.config);
              setModifyConfigModalOpen(true);
              setCurrentAdminId(row.key);
            }}
          >
            Modify Config
          </Button>
        </div>
      )
    }
  ];

  useEffect(() => {
    fetchAdminsList();
  }, []);

  return (
    <div
      style={{
        marginTop: "20px",
        marginLeft: clamp(12, 30),
        marginRight: clamp(12, 30)
      }}
    >
      <div
        style={{
          marginBottom: "10px"
        }}
      >
        <Button
          type="primary"
          onClick={() => {
            setCreateAdminModalOpen(true);
          }}
        >
          Create Admin
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={adminList}
        bordered
        pagination={false}
        scroll={{ x: "max-content" }}
      />
      <UpdateAdminConfigModal
        isModalOpen={modifyConfigModalOpen}
        setIsModalOpen={setModifyConfigModalOpen}
        adminConfig={currentAdminConfig}
        updateAdminConfigState={updateAdminConfigState}
        handleConfigUpdate={updateAdminConfig}
      />
      <NewAdminFormModal
        isModalOpen={createAdminModalOpen}
        setIsModalOpen={setCreateAdminModalOpen}
        handleCreateAdmin={handleCreateAdmin}
      />
    </div>
  );
};

export default AdminManagementDash;
